let showDialog = null;

export function registerConfirmHost(callback) {
    showDialog = callback;
}

export function confirmDialog({
    title,
    text,
    confirmButtonText = 'OK',
    cancelButtonText = 'Отмена',
    confirmButtonVariant = 'primary',
}) {
    return new Promise((resolve) => {
        if (!showDialog) {
            console.error('ConfirmDialogHost is not mounted');
            resolve({isConfirmed: false});
            return;
        }

        showDialog({
            title,
            text,
            confirmButtonText,
            cancelButtonText,
            confirmButtonVariant,
            mode: 'confirm',
            onResolve: resolve,
        });
    });
}

export function alertDialog({
    title,
    text,
    confirmButtonText = 'OK',
}) {
    return new Promise((resolve) => {
        if (!showDialog) {
            console.error('ConfirmDialogHost is not mounted');
            resolve({isConfirmed: true});
            return;
        }

        showDialog({
            title,
            text,
            confirmButtonText,
            confirmButtonVariant: 'primary',
            mode: 'alert',
            onResolve: resolve,
        });
    });
}
